import { action } from 'easy-peasy';
import { Status } from '~/services/api/actTeamMember/types';
import { IActionRestoreTeamMember } from '../types';

const restoreTeamMember: IActionRestoreTeamMember = action((state, teamMemberId) => {
  const updatedList = state.list.map(item =>
    item.id !== teamMemberId ? item : { ...item, status: 'Active' as Status },
  );

  state.list = updatedList;
});

export default restoreTeamMember;
